import { Odds } from '@/modelTypes';

import { BetType } from '../apollo/types/gen/graphql';

export const getOddsRange = (
  odds: Odds,
  setNums: number[],
  betType: BetType,
): { min: number; max: number } => {
  const arrayOfOdds: number[] = [];

  setNums.forEach(setNum => {
    if (!odds[betType] || !odds[betType].detail) {
      // オッズの詳細が取得できなかった場合は「null」を返却
      return null;
    }

    const targetOdds = odds[betType].detail.find(
      oddsInfo => oddsInfo.setNum === setNum,
    );
    if (targetOdds) {
      if (targetOdds.odds) {
        arrayOfOdds.push(targetOdds.odds);
      }
      if (targetOdds.oddsOne && targetOdds.oddsTwo) {
        arrayOfOdds.push(targetOdds.oddsOne, targetOdds.oddsTwo);
      }
    }
  });

  return {
    min: Number.isFinite(Math.min(...arrayOfOdds))
      ? Math.min(...arrayOfOdds)
      : 9999.9,
    max: Number.isFinite(Math.max(...arrayOfOdds))
      ? Math.max(...arrayOfOdds)
      : 9999.9,
  };
};

export const getRefund = (
  odds: Odds,
  setNum: number,
  count: number,
  betType: BetType,
): number => {
  if (!odds[betType] || !odds[betType].detail) {
    // オッズの詳細が取得できなかった場合は「0」を返却
    return 0;
  }

  const targetOdds = odds[betType].detail.find(
    oddsInfo => oddsInfo.setNum === setNum,
  );
  if (targetOdds) {
    if (targetOdds.odds) {
      return targetOdds.odds * 100 * count;
    }
    if (targetOdds.oddsOne && targetOdds.oddsTwo) {
      return targetOdds.oddsOne * 100 * count;
    }
  }

  return 0;
};

export const parseOddsInfo = (oddsInfo: string) => {
  if (oddsInfo == null || oddsInfo == '') {
    return {} as Odds;
  }

  const oddsData: Odds = JSON.parse(oddsInfo);

  // オッズが0の場合は9999.9に置換する
  (Object.keys(oddsData) as BetType[]).forEach(key => {
    if (oddsData[key].detail) {
      oddsData[key].detail.map(d => {
        // eslint-disable-next-line no-param-reassign
        if (d.odds === 0) d.odds = 9999.9;
        // eslint-disable-next-line no-param-reassign
        if (d.oddsOne === 0) d.oddsOne = 9999.9;
        // eslint-disable-next-line no-param-reassign
        if (d.oddsTwo === 0) d.oddsTwo = 9999.9;
        return d;
      });
    }
  });

  return oddsData;
};

export const getCompositeOdds = (
  odds: Odds,
  setNums: number[],
  betType: BetType,
): number => {
  let compositeNum: number = 0;
  setNums.forEach(setNum => {
    if (!odds[betType] || !odds[betType].detail) {
      // オッズの詳細が取得できなかった場合は「null」を返却
      return null;
    }

    const targetOdds = odds[betType].detail.find(
      oddsInfo => oddsInfo.setNum === setNum,
    );
    if (targetOdds) {
      if (targetOdds.odds) {
        compositeNum += 1 / targetOdds.odds;
      }
      if (targetOdds.oddsOne && targetOdds.oddsTwo) {
        compositeNum += 1 / targetOdds.oddsOne;
      }
    }
  });

  return 1 / compositeNum;
};
